<template lang="pug">
  .server
    .page-header
      h2 Multi 1v1 Arena
      router-link.button.flex-right.icon(to="/multi1v1/records") #[format-list-numbers-icon] Leaderboards
      a.button(href="https://www.gametracker.com/server_info/raid-gaming.net:27016/", target="_blank") GameTracker

    .block-wrapper
      .server-info
        h3 Server Info
        ul(v-if="server.id")
          li Server Name: #[span(:title="server.name") {{ server.name }}]
          li Server IP: #[a.ip(title="Server IP (Click to join)", :href="`steam://connect/${server.ip}`") {{ server.ip }}]
          li Current Map: {{ server.map }}
          li Online Players: {{ server.players.length + server.bots.length }}
        ul(v-else)
          li Loading server info...

      .my-stats
        h3 Your Statistics
        ul(v-if="!user")
          li Sign in to view your statistics
        template(v-else)
          template(v-if="user.steamID")
            ul(v-if="stats")
              li Rank: {{ stats.rank }}
              li Score: {{ stats.score }}
              li Kills: {{ stats.kills }}
              li Deaths: {{ stats.deaths }}
            ul(v-else)
              li Loading stats...
          ul(v-else)
            li Set your Steam ID in your #[a.highlight(:href="'https://raid-gaming.net/profile/' + user.id + '-' + user.seoName + '/edit/'") forum profile settings] to view your statistics

    .spacer

    h3.player-list-title(@click="playerListVisible = !playerListVisible", :class="{ active: playerListVisible }") Online Players ({{ server.players.length + server.bots.length }}/{{ server.maxplayers }})
      chevron-down-icon
    ul.player-list(v-if="playerListVisible")
      li(v-for="player of server.players.concat(server.bots)")
        p {{ player.name }}
      li(v-if="server.players.concat(server.bots).length <= 0")
        p Server empty

    p.last-updated Last updated {{ updated }} second(s) ago
</template>

<script>
import ServerInfoService from '@/services/ServerInfo';
import ClientStatsService from '@/services/ClientStats';

import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue';
import FormatListNumbersIcon from 'vue-material-design-icons/FormatListNumbered.vue';

export default {
  name: 'server-csgo-1v1',
  components: {
    ChevronDownIcon,
    FormatListNumbersIcon,
  },
  data() {
    return {
      server: {
        players: [],
        bots: [],
      },
      stats: null,
      updated: 0,
      playerListVisible: true,
      timer: null,
      timerUpdated: null,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    async update() {
      const response = await ServerInfoService.updateCSGO('multi1v1');
      if (response.error) {
        console.log(response.error);
      } else {
        this.server = response.data;
      }
      this.updated = 0;
    },
    async updateStats() {
      if (this.user && this.user.steamID) {
        const response = await ClientStatsService.getCSGO(this.user.steamID, 'multi1v1');
        if (response.error) {
          console.log(response.error);
        } else {
          this.stats = response.data;
        }
      }
    },
  },
  created() {
    this.updateStats();
    this.update();
    this.timer = setInterval(this.update, 30000);
    this.timerUpdated = setInterval(() => {
      this.updated += 1;
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.timerUpdated);
  },
};
</script>
